export default {
  brewery: 'celladorAlesSyndicate',
  info_url: 'http://landing.tavour.com/CelladorAlesSyndicate/',
  title: {
    in_progress: '',
    success: 'You Joined Cellador Ales\' Syndicate at Large!',
    subtext: 'Join Cellador Ales\' Syndicate at Large',
    sub_subtext: ' The Syndicate at Large is a twice-yearly subscription that ships Cellador Ales directly to your door. ' +
      'Every six months, you\'ll receive a six-bottle package featuring our wild ales, farmhouse beers, and barrel-aged releases.',
  },
  review: {
    summary: [
      'You are joining Cellador Ales\' Syndicate at Large.',
      'By signing up, your card will be charged $185 per shipment (shipping included). ' +
      'You will receive two shipments per year, timed to when the beers are ready. ' +
      'Each shipment contains six bottles drawn from Cellador\'s barrel program and member-only releases.',
      'You will have the option to opt out by emailing support@tavour.com.',
      'You will receive a notification when your box has been charged and shipped.',
    ],
    button_text: 'Join the Syndicate!',
  },
};



// WEBPACK FOOTER //
// ./src/settings/celladorAlesSyndicate.js